import { render, staticRenderFns } from "./Pvc.vue?vue&type=template&id=31516008&"
import script from "./Pvc.vue?vue&type=script&lang=js&"
export * from "./Pvc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports